module.exports = __webpack_public_path__ + "img/calendar.804add9a.png";